<section class="voucher-container" [ngStyle]="{'background': _commonService.isAuthenticated() ? '#fff' : '#FAFAFA'}">
    <div class="mini-heading flex space-between w100">
        <!-- Annual Milestone Benefit -->
        {{cardData?.campaignName}}
        <div class="tag {{cardData?.status}} pad-top-2 pad-bot-2 pad-10 flex align-center f400" *ngIf = "_commonService.isAuthenticated()">
            <img class="stat-image" *ngIf = "cardData?.status == 'claimed'" src = "https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/claim-tick.svg">
            <img class="stat-image" *ngIf = "cardData?.status == 'locked'"src = "https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/locked.svg">
            <img class="stat-image" *ngIf = "cardData?.status == 'missed'"src = "https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/missed.svg">
            <img class="stat-image" *ngIf = "cardData?.status == 'unlocked'"src = "https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/unlocked.svg">
            <img class="stat-image" *ngIf = "cardData?.status == 'results_awaited'" src = "../../../assets/svg/result-awaited.svg">


            <span *ngIf="cardData?.status !== 'no-data'">{{label}}</span>
        </div>
        <div *ngIf = "!_commonService.isAuthenticated()" class="pre-tag flex align-center justify-center">
            <img src="https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/locked.svg">
        </div>
    </div>
    <div class="heading flex align-center">
        <div *ngIf = "cardData?.merchantDetails?.merchantLength == 1" class="merchant-logo mar-right-10">
            <img [src]="(cardData.benefitImg)? cardData.benefitImg : (cardData?.merchantDetails?.merchantIcons[0]?.logo_url) || '../../../assets/images/image-coming-soon.png'" class="img-fluid" style="height:100%;width:100%;">
              <!-- <img class="img-merchant" [ngStyle]="{'object-fit':(cardData.benefitImg)? 'cover' : 'fill'}" [src]="cardData.benefitImg ? cardData.benefitImg : '../../../assets/images/image-coming-soon.png'" alt="">           -->
        </div>
        <p>
          {{cardData?.benefitTitle}}
        </p>
    </div>
    <div class="logos flex pad-bot-10" *ngIf = "cardData?.merchantDetails?.merchantLength > 1">
        <div *ngFor = "let merchant of cardData?.merchantDetails?.merchantIcons" class="merchant-logo mar-right-10">
          <img [ngStyle]="{'object-fit':(merchant?.logo_url || merchant?.attributes?.item?.data?.attributes?.image_url)? 'cover' : 'fill'}"
          [src]="merchant?.logo_url || merchant?.attributes?.item?.data?.attributes?.image_url ? merchant?.logo_url || merchant?.attributes?.item?.data?.attributes?.image_url : '../../../assets/images/image-coming-soon.png'" class="img-fluid"
          style="height:100%;width:100%;">
            <!-- <img *ngIf="merchant?.logo_url" [src] = "merchant?.logo_url" class="img-fluid">
            <img *ngIf="!merchant?.logo_url" src="../../../assets/images/image-coming-soon.png" class="img-fluid" style="height:100%;width:100%;"> -->

        </div>
        <div class="merchant-logo-num fnt-12 f500 flex align-center justify-center" *ngIf = "cardData?.merchantDetails?.merchantLength > 4">
            +{{cardData?.merchantDetails?.merchantLength - 4}}
        </div>
    </div>
    <div class="description f400">
        <!-- On achieving annual spend milestone on your AU Bank Zenith Card -->
        {{cardData?.description}}
    </div>
    <div class="validity">
        <span>Validity:</span><span class="date"> {{cardData?.expDate | date : "dd-MM-YY"}} </span>
    </div>
    <div class="badge-section">

        <app-poshvine-badge *ngFor="let card of cardData?.cardName" [labelText]="card"></app-poshvine-badge>
    </div>
    <div class="voucher-panel" *ngIf=" _commonService.isAuthenticated() && cardData?.status === 'claimed' && false" >
      <div style="width: 100%;" class="">
        <app-poshvine-link [labelText]="'View vouchers'" (click)="fetchVouchers();$event.stopPropagation();"></app-poshvine-link>
      </div>
      <ng-container *ngIf="isVoucherLoaded">
        <div *ngIf="giftcardsVoucherData?.length > 0" class="w100">
          <ng-container *ngFor="let gcItem of giftcardsVoucherData">
            <br style="width: 100%;">
            <div class="merchant-panel">
              <div class="merchant-icon">
                <img [src]="gcItem?.attributes?.gift_card_orders[0]?.gift_card_image">
              </div>
              <div class="merchant-heading">
                {{gcItem?.attributes?.gift_card_orders[0]?.gift_card_title}}
              </div>
            </div>
            <ng-container *ngFor="let gc of gcItem?.attributes?.gift_card_orders">
              <div class="denominations-section">
                <div class="item">
                  <div class="label">Denomination</div>
                  <div class="quantity">{{gc?.denomination|indianCurrency}}</div>
                </div>
                <div class="item">
                  <div class="label">Quantity</div>
                  <div class="quantity">{{gc?.quantity}}</div>
                </div>
              </div>
              <ng-container *ngIf="gc?.vouchers?.length">
                <ng-container *ngFor="let voucher of gc?.vouchers; let i = index">
                  <div class="cc-container">
                    <app-poshvine-copy-code [title]="'ID'" [value]="voucher?.card_number"></app-poshvine-copy-code>
                  </div>
                  <div class="cc-container">
                    <app-poshvine-copy-code [title]="'Pin'" [value]="voucher?.pin"></app-poshvine-copy-code>
                  </div>
                  <hr *ngIf="gc?.vouchers?.length !== (i + 1)">
                </ng-container>
              </ng-container>

            </ng-container>
            <br>
          </ng-container>

        </div>
        <div *ngIf="membershipsVoucherData?.length > 0" class="w100">
          <ng-container *ngFor="let membershipItem of membershipsVoucherData">
            <div class="merchant-panel">
              <div class="merchant-icon">
                <img [src]="membershipItem?.attributes?.membership?.image">
              </div>
              <div class="merchant-heading">
                {{membershipItem?.attributes?.membership?.title}}
              </div>
            </div>
              <!-- <div class="denominations-section">
                <div class="item">
                  <div class="label">Denomination</div>
                  <div class="quantity">{{gc?.denomination|indianCurrency}}</div>
                </div>
                <div class="item">
                  <div class="label">Quantity</div>
                  <div class="quantity">{{gc?.quantity}}</div>
                </div>
              </div> -->
                <app-poshvine-copy-code *ngIf="membershipItem?.attributes?.membership_voucher?.code"
                [title]="'CODE'" [value]="membershipItem?.attributes?.membership_voucher?.code"></app-poshvine-copy-code>
                <app-poshvine-copy-code *ngIf="membershipItem?.attributes?.membership_voucher?.pin"
                [title]="'PIN'" [value]="membershipItem?.attributes?.membership_voucher?.pin"></app-poshvine-copy-code>
            <br>
          </ng-container>

        </div>
      </ng-container>
    </div>
    <div class="claim-section" *ngIf = " _commonService.isAuthenticated() && cardData?.status === 'unlocked'">
        <app-poshvine-link [labelText]="'Claim Now'"></app-poshvine-link>
    </div>
</section>
